import { useEffect, useReducer, useState } from "react";
import Select from "react-select";
import { optionSelector } from "../../../config/apiSPA";
const initialForm = {
  trId: null,
  category: null,
  remark: "",
  sasaranPelatihan: [],
};

function reducer(state, action) {
  switch (action.type) {
    case "trId":
      return { ...state, trId: action.value };
    case "category":
      return { ...state, category: action.value };
    case "remark":
      return { ...state, remark: action.value };
    case "sasaranPelatihan":
      const newGoal = [...state.sasaranPelatihan];
      newGoal[action.index] = action.value;
      return { ...state, sasaranPelatihan: newGoal };
    case "RESET":
      return initialForm;
    default:
      return state;
  }
}

const maxChar = 100;
function NewEventFormTel3FromOutstanding({ onChange = () => {}, id }) {
  const [formData, formDataDispatch] = useReducer(reducer, initialForm);
  const [trainingOption, setTrainingOption] = useState([]);
  const [ctgrOpt, setCtgOpt] = useState([]);
  const [presTitle, setPresTitle] = useState("-");
  const [charCount, setCharCount] = useState([0, 0, 0, 0]);
  const [charWarning, setCharWarning] = useState([false, false, false, false]);

  const handleChangeTrainingGoals = (val, index) => {
    if (val.trim() === "") {
      formDataDispatch({ type: "sasaranPelatihan", value: null, index: index });
    }
    formDataDispatch({ type: "sasaranPelatihan", value: val, index: index });
    charCounter(val, index);
  };
  const charCounter = (val, index) => {
    const len = val.length;
    setCharCount((prev) => {
      const u = [...prev];
      u[index] = len;
      return u;
    });
    setCharWarning((prev) => {
      const y = [...prev];
      y[index] = len > maxChar ? true : false;
      return y;
    });
  };

  const loadData = async () => {
    const trOpt = await optionSelector("/training-report");
    const ctOpt = await optionSelector("/tel3-category");
    formDataDispatch({ type: "trId", value: id });
    setPresTitle(trOpt.find((i) => i.value == id)?.label || "-");
    setTrainingOption(trOpt);
    setCtgOpt(ctOpt);
  };
  useEffect(() => {
    onChange(formData);
  }, [formData]);
  useEffect(() => {
    loadData();
  }, []);
  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-12">
            <div className="row">
              <div className="col-xl-12">
                <div className="form-group mb-3">
                  <label className="form-label text-theme">
                    Training Event<span className="text-danger">*</span>
                  </label>
                  <h5>{presTitle}</h5>
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="activityId">
                    Category<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="activityId"
                    options={ctgrOpt}
                    onChange={(e) => formDataDispatch({ type: "category", value: e.value })}
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="remark">
                    Remark
                  </label>
                  <textarea className="form-control" id="remark" onChange={(e) => formDataDispatch({ type: "remark", value: e.target.value })}></textarea>
                </div>
                <hr />
                <h5 className="text-theme mb-2">Training Goals</h5>

                <p className="text-muted mb-3">
                  Please describe your objectives and expectations for this training program. What skills, knowledge, or outcomes do you hope to achieve after completing this training? [sings].{" "}
                  <span className="text-theme">(Minimal harus ada 1 training goals)</span>
                </p>
                <div className="form-group mb-3 d-flex align-items-start">
                  <label className="form-label text-theme me-2" style={{ width: "20px" }}>
                    1.
                  </label>
                  <div className="w-100">
                    <p className={charWarning[0] ? "mb-0 text-danger" : "mb-0"} style={{ fontSize: "11px", lineHeight: "1.2" }}>
                      {charCount[0]}/{maxChar} characters
                    </p>
                    <textarea
                      className="form-control"
                      id="remark"
                      placeholder="Contoh: Peserta mampu melakukan inspeksi harian (daily check) dan berkala pada unit excavator PC785-6R."
                      onChange={(e) => handleChangeTrainingGoals(e.target.value, 0)}
                    ></textarea>
                  </div>
                </div>
                <div className="form-group mb-3 d-flex align-items-start">
                  <label className="form-label text-theme me-2" style={{ width: "20px" }}>
                    2.
                  </label>
                  <div className="w-100">
                    <p className={charWarning[1] ? "mb-0 text-danger" : "mb-0"} style={{ fontSize: "11px", lineHeight: "1.2" }}>
                      {charCount[1]}/{maxChar} characters
                    </p>
                    <textarea className="form-control" id="remark" onChange={(e) => handleChangeTrainingGoals(e.target.value, 1)}></textarea>
                  </div>
                </div>
                <div className="form-group mb-3 d-flex align-items-start">
                  <label className="form-label text-theme me-2" style={{ width: "20px" }}>
                    3.
                  </label>
                  <div className="w-100">
                    <p className={charWarning[2] ? "mb-0 text-danger" : "mb-0"} style={{ fontSize: "11px", lineHeight: "1.2" }}>
                      {charCount[2]}/{maxChar} characters
                    </p>
                    <textarea className="form-control" id="remark" onChange={(e) => handleChangeTrainingGoals(e.target.value, 2)}></textarea>
                  </div>
                </div>
                <div className="form-group mb-3 d-flex align-items-start">
                  <label className="form-label text-theme me-2" style={{ width: "20px" }}>
                    4
                  </label>
                  <div className="w-100">
                    <p className={charWarning[3] ? "mb-0 text-danger" : "mb-0"} style={{ fontSize: "11px", lineHeight: "1.2" }}>
                      {charCount[3]}/{maxChar} characters
                    </p>
                    <textarea className="form-control" id="remark" onChange={(e) => handleChangeTrainingGoals(e.target.value, 3)}></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default NewEventFormTel3FromOutstanding;
